const SLIDER_MONEY = 'money';
const SLIDER_AGE = 'age';

export { SLIDER_MONEY, SLIDER_AGE };
